<template>
  <v-toolbar-title>
    <NuxtLink
      class="site-title-link"
      to="/"
    >
      <SiteLogo class="mr-2" />

      <slot>
        <SiteTitle />
      </slot>
    </NuxtLink>
  </v-toolbar-title>
</template>

<style scoped lang="scss">
.v-toolbar__content > .v-toolbar-title {
  margin-inline-start: 0.5rem;
}

.site-title-link {
  display: flex;
  overflow: hidden;
}
</style>
